// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PM9P","label":"styles_label__3iKfF"};